export const NOTIFICATION_CHANGED_EVENT = 'suyuan:notification-changed';

const listeners = [];

export function emitNotificationChanged(payload = {}) {
  listeners.slice().forEach((listener) => {
    listener(payload);
  });
}

export function onNotificationChanged(listener) {
  if (typeof listener !== 'function') {
    return () => {};
  }
  listeners.push(listener);
  return () => {
    const index = listeners.indexOf(listener);
    if (index >= 0) {
      listeners.splice(index, 1);
    }
  };
}
